import { render, staticRenderFns } from "./subgroup-toggle-button.vue?vue&type=template&id=1d3f07c4&scoped=true"
import script from "./subgroup-toggle-button.vue?vue&type=script&lang=js"
export * from "./subgroup-toggle-button.vue?vue&type=script&lang=js"
import style0 from "./subgroup-toggle-button.vue?vue&type=style&index=0&id=1d3f07c4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f07c4",
  null
  
)

export default component.exports